module.exports = __webpack_public_path__ + "static/img/logo.70263dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/logo.png
// module id = Z/ET
// module chunks = 0